import { ApolloCache } from '@apollo/client';
import gql from 'graphql-tag';
import {
  BookmarkTypeEnum,
  GetBookmarksDocument,
  GetBookmarksQuery,
  GetBookmarksQueryVariables,
} from '@src/graphql/generated';

export function removeBookmarkFromCache(cache: ApolloCache<any>, userId: string): void {
  cache.writeFragment({
    data: {
      hasBookmarked: false,
    },
    fragment: gql`
      fragment User on UserType {
        hasBookmarked
      }
    `,
    id: `UserType:${userId}`,
  });

  const query = {
    query: GetBookmarksDocument,
    variables: {
      type: BookmarkTypeEnum.USER,
    },
  };

  const data = cache.readQuery<GetBookmarksQuery, GetBookmarksQueryVariables>(query);

  if (data) {
    const updatedBookmarks = data.bookmarks.result.filter(bookmark => {
      if (bookmark.__typename === 'BookmarkUserType') {
        return bookmark.user.id !== userId;
      }

      return false;
    });

    const updatedData = {
      ...data,
      bookmarks: {
        ...data.bookmarks,
        pagination: {
          ...data.bookmarks.pagination,
          totalCount: updatedBookmarks.length,
        },
        result: updatedBookmarks,
      },
    };

    cache.writeQuery({
      ...query,
      data: updatedData,
    });
  }
}

export function addBookmarkToCache(
  cache: ApolloCache<any>,
  bookmark: GetBookmarksQuery['bookmarks']['result'][number],
): void {
  const query = {
    query: GetBookmarksDocument,
    variables: {
      type: BookmarkTypeEnum.USER,
    },
  };

  const data = cache.readQuery<GetBookmarksQuery, GetBookmarksQueryVariables>(query);

  if (data) {
    const updatedBookmarks = [...data.bookmarks.result, bookmark];

    const updatedData = {
      ...data,
      bookmarks: {
        ...data.bookmarks,
        pagination: {
          ...data.bookmarks.pagination,
          totalCount: updatedBookmarks.length,
        },
        result: updatedBookmarks,
      },
    };

    cache.writeQuery({
      ...query,
      data: updatedData,
    });
  }
}
